import { useRouter } from 'next/router'
import { LOCATION_SEARCH_TYPE } from '@/types'
import AppRoutes from '@/constants/app-routes'

export default function useTypeAheadForDisplayName() {
  const { pathname, query } = useRouter()
  const {
    tab,
    'ambig-origin-city': ambigOriginCity,
    'ambig-dest-city': ambigDestCity
  } = query || {}
  const isFlightRoute = pathname === AppRoutes.flights || tab === 'flights'
  const haveCustomItemName = ambigOriginCity || ambigDestCity

  const itemDisplayNameTransform = (
    item: LOCATION_SEARCH_TYPE | Record<string, never> | null
  ) => {
    if (item === null) {
      return
    }

    if (isFlightRoute && item.type === 'AIRPORT') {
      const displayNameSegments = [
        item.cityName,
        ...((item.countryCode === 'US' || item.countryCode === 'CA') &&
        item.stateCode
          ? [item.stateCode]
          : []),
        ...(item.countryCode !== 'US' ? [item.country] : [])
      ]

      return `${displayNameSegments.join(', ')} (${item.id})`
    }
    return item.itemName
  }

  return isFlightRoute && !haveCustomItemName ? itemDisplayNameTransform : null
}
